import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Progress,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";
import logo from "../../assets/images/karak_logo_new.png";
import { postSubmitForm } from "../../helpers/forms_helper";
import preloader from "../../helpers/preloader";
import showNotification from "../../helpers/show_notification";
import printDiv from "../../helpers/print_data";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import {
  columnsProductDetails,
  columnsProductInbound,
  columnsProductInboundDetails,
  columnsProductOutbound,
  columnsProductOutboundDetails,
  columnsPurchase,
  columnsPurchaseDetails,
} from "../Reports/Centre/Products/COGSProductColumns";
import moment from "moment";
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered } from "../../helpers/units";
import { getDateRangeFromMonth, mergeDuplicateItemsQuantityForStore, mergeDuplicateProdQuantity, mergeDuplicateProducts } from "../../helpers/commonFunctions";

const COGSProductDebug = (props) => {
  const { SearchBar } = Search;
  const [monthYear, setMonthYear] = useState();
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [filterModalTotal, setFilterModalTotal] = useState(0);
  const [filterModalSubTotal, setFilterModalSubTotal] = useState(0);
  const [filterModalTotalQty, setFilterModalTotalQty] = useState([]);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  function afterFilter(newResult, newFilters) {
    const total = newResult.reduce(
      (partialSum, a) => Number(partialSum) + Number(a.receiving_cost),
      0
    );
    setFilterModalTotal(total.toFixed(2));
  }
  
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  useEffect(() => {
    const currentDay = new Date();
    const previousMonth = moment(currentDay).subtract(1, 'months').format('YYYY-MM');
    // setMonthYear(previousMonth);
    setMonthYear(formatDate(currentDay).slice(0, 7));
    setCurrentMonthYear(formatDate(currentDay).slice(0, 7));
    loadAllBranches()
  }, []);

  useEffect(()=>{
  setMonthYear(props.monthYear)
  },[props.monthYear])

  const [allOrders, setAllOrders] = useState([]);
  
  const loadOrders = async () => {
    try {
      setIsLoading(true);
      setProgress(0);
      setAllOrders([]); 
      if (props.onLoadingChange) {
        props.onLoadingChange(true);
      }
      
      const branchIds = allBranches.map(branch => branch._id);
      const totalBatches = Math.ceil(branchIds.length / BATCH_SIZE);
      let processedBatches = new Set(); // Track which batches we've processed
      
      if(monthYear === currentMonthYear){
        for (let i = 0; i < branchIds.length; i += BATCH_SIZE) {
          // Check if we've already processed this batch
          const batchKey = `${monthYear}-${i}`; // Unique key for this batch        
          if (processedBatches.has(batchKey)) {
            continue; // Skip if already processed
          }
    
          const batchBranchIds = branchIds.slice(i, i + BATCH_SIZE);
          const payload = {
            monthYear: monthYear,
            branch_ids: batchBranchIds
          };
    
          let batchResponse = null;
          try {
            const url = process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_products_report";
            batchResponse = await postSubmitForm(url, payload);
            
            if (batchResponse && batchResponse.status === 1) {
              const newBranchData = batchResponse.data.branches || [];
              
              setAllOrders(prevOrders => {
                // Filter out any branches we're about to add to prevent duplicates
                const newBranchIds = new Set(newBranchData.map(branch => branch._id));
                const filteredPrevOrders = prevOrders.filter(order => !newBranchIds.has(order._id));
                return [...filteredPrevOrders, ...newBranchData];
              });
              
              // Update progress
              const currentBatch = Math.floor(i / BATCH_SIZE) + 1;
              const progressPercentage = Math.round((currentBatch / totalBatches) * 100);
              setProgress(progressPercentage);
              
              // Mark this batch as processed
              processedBatches.add(batchKey);
            }
          } catch (batchError) {
            console.error(`Error processing batch ${i / BATCH_SIZE + 1}:`, batchError);
          } finally {
            // Clear response data
            batchResponse = null;
          }
    
          // Add delay between batches
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }else{
        const payload = {
          monthYear: monthYear,
        };
        const url = process.env.REACT_APP_BASEURL + "reports/cost_of_goods_sold_products_report";
        const res = await postSubmitForm(url, payload);
        if(res.status===1){
          setAllOrders(res.data.branches)
        }else{
          showNotification(res.message,"Error")
        }
      }
      
    } catch (error) {
      console.error("Error loading orders:", error);
      showNotification("Error loading data", "Error");
    } finally {
      setIsLoading(false);
      preloader(false);
      if (props.onLoadingChange) {
        props.onLoadingChange(false);
      }
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [allBranches, setAllBranches] = useState([]);
  const [progress, setProgress] = useState(0);
  const BATCH_SIZE = 5; 

  const loadAllBranches = async () => {
   try {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store) => store.type === "Branch" || store.type === "CENTRAL STORE" || store.type === "CENTRAL KITCHEN STORE" && store.is_active === true)
      // const sorted =  res.sort((a, b) => a.name.localeCompare(b.name)) 
      setAllBranches(res);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    console.error(error)
   } finally{
    preloader(false)
   }
  };

  useEffect(() => {
    let isMounted = true;
  
    const fetchData = async () => {
      if (monthYear && allBranches.length > 0) {
        setAllOrders([]);
        if (isMounted) {
          await loadOrders();
        }
      }
    };
  
    fetchData();
  
    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [monthYear, allBranches]);

  const [purchaseModal, setPurchaseModal] = useState(false);
    const [openingModal, setOpeningModal] = useState(false);
  const [closingModal, setClosingModal] = useState(false);
  const [productOutboundModal, setProductOutboundModal] = useState(false);
  const [productInboundModal, setProductInboundModal] = useState(false);

  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [productOutboundDetailsModal, setProductOutboundDetailsModal] =
    useState(false);
  const [productInboundDetailsModal, setProductInboundDetailsModal] =
    useState(false);

  const [purchaseDetails, setPurchaseDetails] = useState([]);
  const [productOutboundDetails, setProductOutboundDetails] = useState([]);
  const [productInboundDetails, setProductInboundDetails] = useState([]);

  const dateFrom = moment(monthYear).startOf("month").format("YYYY-MM-DD");
  const dateTo = moment(monthYear).endOf("month").format("YYYY-MM-DD");

  const loadPurchaseDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_costing_summary_product_orders";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        from_cogs:true,
       product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;  
        
        data.forEach(item => {
          const { delivery_details } = item;
          const { 
            receiving_cost = 0,
            unit_levels,
            received_quantity
          } = delivery_details || {};
  
          totalReceivingCost += Number(receiving_cost);
  
          if (unit_levels && received_quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, received_quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });
  
        // Get display quantity if possible
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.delivery_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;
          
          const summedQuantity = [{
            unit: lowestUnit,
            value: totalLowestUnitQty
          }];
          
          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);          
        }
  
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setPurchaseDetails(response.data);
        setPurchaseDetailsModal(!purchaseDetailsModal);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadProductInboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_inbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
        let totalReceivingCost = 0;
        let totalLowestUnitQty = 0;  
        
        data.forEach(item => {
          const { product_details } = item;
          const { 
            receiving_cost = 0,
            unit_levels,
            quantity
          } = product_details || {};
  
          totalReceivingCost += Number(receiving_cost || 0);
  
          if (unit_levels && quantity) {
            const convertedQty = convertToLowestUnit(unit_levels, quantity);
            totalLowestUnitQty += Number(convertedQty || 0);
          }
        });
  
        let displayQuantity = "";
        const firstDeliveryDetails = data[0]?.product_details;
        if (firstDeliveryDetails?.unit_levels) {
          const { unit_levels } = firstDeliveryDetails;
          const lowestUnit = unit_levels.at(-1).unit;
          
          const summedQuantity = [{
            unit: lowestUnit,
            value: totalLowestUnitQty
          }];
          
          displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
        }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductInboundDetails(response.data);
        setProductInboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const loadProductOutboundDetails = async (item_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL +
        "reports/branchwise_costing_summary_product_transfers_outbound";
      const response = await postSubmitForm(url, {
        branch_id: selectedBranch._id,
        date_from: dateFrom,
        date_to: dateTo,
        product_id: item_id,
      });
      if (response && response.status === 1) {
        const data = response.data;
      let totalReceivingCost = 0;
      let totalLowestUnitQty = 0;  
      
      data.forEach(item => {
        const { product_details } = item;
        const { 
          receiving_cost = 0,
          unit_levels,
          quantity
        } = product_details || {};

        totalReceivingCost += Number(receiving_cost);

        if (unit_levels && quantity) {
          const convertedQty = convertToLowestUnit(unit_levels, quantity);
          totalLowestUnitQty += Number(convertedQty || 0);
        }
      });
      let displayQuantity = "";
      const firstDeliveryDetails = data[0]?.product_details;
      if (firstDeliveryDetails?.unit_levels) {
        const { unit_levels } = firstDeliveryDetails;
        const lowestUnit = unit_levels.at(-1).unit;
        
        const summedQuantity = [{
          unit: lowestUnit,
          value: totalLowestUnitQty
        }];
        
        displayQuantity = GetUpdatedDelivered(summedQuantity, unit_levels);
      }
        preloader(false);
        setFilterModalSubTotal(totalReceivingCost.toFixed(2));
        setFilterModalTotalQty(displayQuantity);
        setProductOutboundDetails(response.data);
        setProductOutboundDetailsModal(true);
      } else {
        preloader(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

       const getPositiveNumber = (value) => {
        const num = Number(value || 0);
        return num > 0 ? num : 0;
      };

      const calculateCOGS = (row) => {
        const cogs =
          Number(row.product_cost_opening ? row.product_cost_opening : 0) +
          Number(row.product_purchase_cost) +
          Number(row.product_inbound_transfer_cost) -
          Number(row.product_outbound_transfer_cost) -
          Number(row.product_cost);
        
        return isNaN(cogs) ? 0 : cogs;
      };
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Branch"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Opening"),
      dataField: "product_cost_opening",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
     formatter: (cell, row, rowIndex) => {
          let isDisabled =  row?.product_details_opening?.length===0 
            return (
              <span
                className={`${isDisabled ? null : `text-info mr-2`}`}
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    if(isDisabled) return
                  // console.log(row,"row");
                    // let unique = mergeDuplicateProductsQuantityForOpening(row.product_details_opening || []);
                    let total = row.product_details_opening.reduce((partialSum, a) => Number(partialSum) + Number(a.total_cost), 0);
                    setFilterModalTotal(Number(total.toFixed(2)))
                    setSelectedBranch(row);
                    setSelectedRow(row.product_details_opening)
                    setOpeningModal(true)
                }}
              >
                {row.product_cost_opening ? row.product_cost_opening : "0.00"}
              </span>
            );
          },
    },
    {
      dataField: "product_purchase_cost",
      text: props.t("Purchase"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = row.type !== "Branch";
        return (
          <span
          className={`mr-2 ${isDisabled ? '' : 'text-info'}`}
          title={isDisabled ? "Not available for this type" : "View Details"}
          style={{ 
           cursor: isDisabled ? "not-allowed" : "pointer",
           pointerEvents: isDisabled ? "none" : "auto"
         }}
            disabled={isDisabled}
            onClick={() => {
             if (isDisabled) return;
              let unique = mergeDuplicateProducts(row.product_order_details)
              setSelectedRow(unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.product_purchase_cost);
              setPurchaseModal(true);
            }}
          >
            {row.product_purchase_cost ? row.product_purchase_cost : "0.00"}
          </span>
        );
      },
    },
    {
      dataField: "product_outbound_transfer_cost",
      text: props.t("Out Tran"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = row.type !== "Branch";
        const handleStoreOutbound = async () => {
          try {
            preloader(true);
            const dateRange = getDateRangeFromMonth(monthYear);
            const startDate = moment(dateRange.startDate);
            const endDate = moment(dateRange.endDate);
            const midDate = moment(dateRange.startDate).date(15);
        
            const firstHalfRange = {
              dateFrom: startDate.format('YYYY-MM-DD'),
              dateTo: midDate.format('YYYY-MM-DD')
            };
        
            const secondHalfRange = {
              dateFrom: midDate.add(1, 'days').format('YYYY-MM-DD'),
              dateTo: endDate.format('YYYY-MM-DD')
            };
        
            const url = process.env.REACT_APP_BASEURL + "reports/cogs_stores_products_outbound_details";
            
            const [firstHalfResponse, secondHalfResponse] = await Promise.all([
              postSubmitForm(url, {
                store_id: row._id,
                date_from: firstHalfRange.dateFrom,
                date_to: firstHalfRange.dateTo
              }),
              postSubmitForm(url, {
                store_id: row._id,
                date_from: secondHalfRange.dateFrom,
                date_to: secondHalfRange.dateTo
              })
            ]);
        
            if (firstHalfResponse?.status === 1 && secondHalfResponse?.status === 1) {
              const mergedData = mergeDuplicateItemsQuantityForStore([
                ...(firstHalfResponse.data.outbound_details || []),
                ...(secondHalfResponse.data.outbound_details || [])
              ],false);
              // console.log(mergedData.length,"mergedData length")
              // console.log(firstHalfResponse.data.outbound_details.length + secondHalfResponse.data.outbound_details.length,"response length")
              const totalofMerge = mergedData.reduce((partialSum, a) => Number(partialSum) + Number(a.receiving_cost),0);
              // console.log(firstHalfResponse.data.total_outbound_cost+secondHalfResponse.data.total_outbound_cost,"res total")
              // console.log(totalofMerge,"total");
              
              setSelectedBranch(row);
              setSelectedRow(mergedData);
              setFilterModalTotal(totalofMerge.toFixed(2));
              setProductOutboundModal(true);
            } else {
              showNotification(
                firstHalfResponse?.message || secondHalfResponse?.message || "Error fetching data", 
                "Error"
              );
            }
          } catch (error) {
            console.error("Error fetching store outbound data:", error);
            showNotification("Error loading data", "Error");
          } finally {
            preloader(false);
          }
        };
        const handleBranchOutbound = () => {
          const filtered = row?.product_transfer_details?.filter(ob => ob.is_outbound) || [];
          const unique = mergeDuplicateProdQuantity(filtered);
          
          setSelectedBranch(row);
          setSelectedRow(unique);
          setFilterModalTotal(row.product_outbound_transfer_cost);
          setProductOutboundModal(true);
        };
      
        const handleClick = () => {
          if (isDisabled) {
            handleStoreOutbound();
          } else {
            handleBranchOutbound();
          }
        };
         return (
           <span
             className="text-info mr-2"
             title="View Details"
             style={{ cursor: "pointer" }}
             onClick={handleClick}
             >
             {row.product_outbound_transfer_cost
               ? row.product_outbound_transfer_cost
               : "0.00"}
           </span>
         );
       },
    },
    {
      dataField: "product_inbound_transfer_cost",
      text: props.t("In Tran"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = row.type !== "Branch";
        return (
          <span
          className={`mr-2 ${isDisabled ? '' : 'text-info'}`}
          title={isDisabled ? "Not available for this type" : "View Details"}
          style={{ 
           cursor: isDisabled ? "not-allowed" : "pointer",
           pointerEvents: isDisabled ? "none" : "auto"
         }}
          disabled={isDisabled}
            onClick={() => {
             if (isDisabled) return;
              let filtered = row?.product_transfer_details.filter((ob)=>ob.is_inbound) || []
              let unique = mergeDuplicateProdQuantity(filtered); 
              setSelectedRow(prev=>prev=unique);
              setSelectedBranch(row);
              setFilterModalTotal(row.product_inbound_transfer_cost);
              setProductInboundModal(true)
            }}
          >
            {row.product_inbound_transfer_cost
              ? row.product_inbound_transfer_cost
              : "0.00"}
          </span>
        );
      },
    },
    {
      text: props.t("Closing"),
      dataField: "product_cost",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
         formatter: (cell, row) => {
                          const params = `?month=${monthYear}&store_id=${row._id}`;
                          const currentMonthYear = moment().format("YYYY-MM")            
                          const isDisabled = monthYear !== currentMonthYear 
                          const isEmpty =  row?.product_details?.length===0 
      
                          if(!isDisabled){
                              return (
                                  <Link 
                                    to={`/products/branchwise_balance_report${params}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-info"
                                    title="View Details"
                                  >
                                    {cell ? cell : "0.00"}
                                  </Link>
                                );
                          } else{
                              return (
              <span
                className={`${isEmpty ? null : `text-info`}`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                if(isEmpty) return
                // let unique = mergeDuplicateProductsQuantityForOpening(row.product_details || []);
                let total = row.product_details.reduce((partialSum, a) => Number(partialSum) + Number(a.total_cost), 0);
                setFilterModalTotal(Number(total.toFixed(2)))
                  setSelectedBranch(row);
                  setSelectedRow(row.product_details);
                  setClosingModal(true)
                }}
                title="View Details"
              >
                {cell ? cell : "0.00"}
              </span>
            );
                          }
                                
                        }
    },
    {
      text: props.t("COGS"),
      dataField: "cogs",
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {    
        const cogsA = calculateCOGS(rowA);
        const cogsB = calculateCOGS(rowB);
    
        if (order === 'asc') {
          return cogsA - cogsB;
        }
        return cogsB - cogsA;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      formatter: (cell, row, rowIndex) => {
        let cogs =calculateCOGS(row)

        if (isNaN(cogs)) {
          cogs = "0.00";
        } else {
          cogs = cogs.toFixed(2);
        }
        return cogs;
      },
    },
    {
          text: props.t("Used"),
          dataField: "used_product_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
          formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_id=${row._id}`;
                  return (
                    <Link 
                      to={`/products/branchwise_used_cost_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Waste"),
          dataField: "waste_product_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
          formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_name=${row.name}`;
                  return (
                    <Link 
                      to={`/products/branchwise_wasted_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Discard"),
          dataField: "discard_product_cost",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "6%" };
          },
           formatter: (cell, row) => {
                  const params = `?month=${monthYear}&store_name=${row.name}`;
                  return (
                    <Link 
                      to={`/products/branchwise_discarded_report${params}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                      title="View Details"
                    >
                      {cell ? cell : "0.00"}
                    </Link>
                  );
                },
        },
        {
          text: props.t("Diff"),
          dataField: "difference",
          sort: true,
          sortFunc: (a, b, order, dataField, rowA, rowB) => {
            const calcDifference = (row) => {
              const cogs = calculateCOGS(row);
        
                const usedItemCost = getPositiveNumber(row.used_product_cost) + 
                getPositiveNumber(row.waste_product_cost) + 
                getPositiveNumber(row.discard_product_cost)
    
              return Math.abs(cogs - usedItemCost);
            };
        
            const diffA = calcDifference(rowA);
            const diffB = calcDifference(rowB);
        
            if (order === 'asc') {
              return diffA - diffB;
            }
            return diffB - diffA;
          },
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
          formatter: (cell, row, rowIndex) => {
            try {
              const cogs = calculateCOGS(row);
        
              const usedItemCost = getPositiveNumber(row.used_product_cost) + 
              getPositiveNumber(row.waste_product_cost) + 
              getPositiveNumber(row.discard_product_cost)
    
              const difference = Math.abs(cogs - usedItemCost);
        
              return isNaN(difference) ? "0.00" : difference.toFixed(2);
        
            } catch (error) {
              console.error('Error calculating difference:', error);
              return "0.00";
            }
          },
          footer: true,
        }
  ];

  const columnPurchase = columnsPurchase(
    props,
    loadPurchaseDetails,
    selectedRow,
    selectFilter,
    dynamicSort
  );

  const columnPurchasedetails = columnsPurchaseDetails(props, selectFilter,monthYear);

  const columnsProductInBound = columnsProductInbound(
    props,
    loadProductInboundDetails,
    selectFilter,
    selectedRow,
    dynamicSort
  );

  const columnsProductInBoundDetails = columnsProductInboundDetails(
    props,
    selectFilter,
    productInboundDetails,
    dynamicSort
  );
  const columnsProducts = columnsProductDetails(props)
  const columnsProductOutBound = columnsProductOutbound(
    props,
    loadProductOutboundDetails,
    selectFilter,
    selectedBranch,
    dynamicSort
  );

  const columnsProductOutBoundDetails = columnsProductOutboundDetails(
    props,
    selectFilter,
    productOutboundDetails,
    dynamicSort
  );

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
    const fileName = "cogs_report_products";
    const exportType = "xls";

    let data_to_export = allOrders;
    //console.log(data_to_export);

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        let cogs = calculateCOGS(v);
        const totalUsedCost = getPositiveNumber(v.used_product_cost) + 
        getPositiveNumber(v.waste_product_cost) + 
        getPositiveNumber(v.discard_product_cost)
        if (isNaN(cogs)) {
          cogs = "0.00";
        } else {
          cogs = cogs.toFixed(2);
        }
        data.push({
          Branch: v.name,
          "Opening Cost": v.product_cost_opening,
          "Purchase Cost": v.product_purchase_cost,
          "Outbound Transfer": v.product_outbound_transfer_cost,
          "Inbound Transfer": v.product_inbound_transfer_cost,
          "Closing Cost": v.product_cost,
          COGS: cogs,
          Used: v.used_product_cost,
          Waste: v.waste_product_cost,
          Discard: v.discard_product_cost,
          Diff: Math.abs(Number(cogs) - totalUsedCost).toFixed(2),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                 {isLoading && 
                                <div className="mb-3">
                                <Progress
                                  animated
                                  color="info"
                                  value={progress}
                                  style={{ height: '20px',color:"Highlight",fontWeight:"bold" }}
                                >
                                  {Math.round(progress)}%  Loading...
                                </Progress>
                              </div>
                                }
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Cost Of Goods Sold Report (Products)")}
                      <br />
                      <h6>
                        (cogs = opening cost + purchase cost + inbound transfer
                        cost - outbound transfer cost - closing cost)
                      </h6>
                    </CardTitle>
                    <ToolkitProvider
                      keyField="id"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            noDataIndication={
                              isLoading 
                                ? <Spinner size={"md"}/> 
                                : ("No data to display.")
                            }
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
 {/*Opening  modal  start*/}
                     <Modal
                      size="xl"
                      isOpen={openingModal}
                      toggle={() => setOpeningModal(!openingModal)}
                    >
                      <ModalHeader
                        toggle={() => setOpeningModal(!openingModal)}
                      >
                        {" "}
                        <Link
                          to="#"
                          onClick={() => {
                            printDiv("openingDetailsDiv");
                          }}
                          className="btn btn-sm btn-success mr-2"
                        >
                          <i className="fa fa-print"></i> Print
                        </Link>
                      </ModalHeader>
                      <ModalBody>
                        <Row id="openingDetailsDiv">
                          <Col lg={12}>
                            <Row>
                              <Col lg={4}>
                                {" "}
                                <img
                                  src={logo}
                                  alt=""
                                  height="50"
                                  style={{ borderRadius: "5px" }}
                                />{" "}
                              </Col>
                              <Col lg={4}>
                                <CardTitle className="text-center">
                                {props.t("Cost Of Goods Sold Report (Products)")}
                                </CardTitle>{" "}
                              </Col>
                            </Row>{" "}
                            <CardTitle className="text-center">
                              {props.t("(Opening Cost Details)")}
                            </CardTitle>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12}>
                                  <h5>
                                      Branch : {selectedBranch.name} | Total Cost :{" "}
                                      {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                    </h5>
                                    <BootstrapTable
                                      keyField="_id"
                                      data={selectedRow && selectedRow}
                                      columns={columnsProducts}
                                      striped
                                      bootstrap4
                                      hover
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </ModalBody>
                    </Modal>
            {/*Opening  modal  end*/}
            {/*closing  modal  start*/}
                <Modal
                  size="xl"
                  isOpen={closingModal}
                  toggle={() => setClosingModal(!closingModal)}
                >
                  <ModalHeader toggle={() => setClosingModal(!closingModal)}>
                    <Link
                      to="#"
                      onClick={() => printDiv("printDivClosing")}
                      className="btn btn-sm btn-success mr-2"
                    >
                      <i className="fa fa-print"></i> Print
                    </Link>
                  </ModalHeader>
                  <ModalBody>
                    <Row id="printDivClosing">
                      <Col lg={12}>
                        <Row>
                          <Col lg={4}>
                            <img
                              src={logo}
                              alt=""
                              height="50"
                              style={{ borderRadius: "5px" }}
                            />
                          </Col>
                          <Col lg={4}>
                            <CardTitle className="text-center">
                              {props.t("Cost Of Goods Sold Report (Products)")}
                            </CardTitle>
                          </Col>
                        </Row>
                        <CardTitle className="text-center">
                          {props.t("Closing Balance Details")}
                        </CardTitle>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col lg={12}>
                                <h5>
                                  Branch: {selectedBranch?.name} | Total Cost :{" "}
                                      {filterModalTotal.toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                                </h5>
                                <BootstrapTable
                                  keyField="_id"
                                  data={selectedRow && selectedRow}
                                  columns={columnsProducts}
                                  striped
                                  hover
                                  condensed
                            />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </ModalBody>
                </Modal>
           {/*closing  modal  end*/}
          {/* Purchase breakup modal       */}
          <Modal
            size="xl"
            isOpen={purchaseModal}
            toggle={() => setPurchaseModal(!purchaseModal)}
          >
            <ModalHeader toggle={() => setPurchaseModal(!purchaseModal)}>
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiv");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiv">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>
                    </Col>
                    <Col lg={4}></Col>
                  </Row>

                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>

                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnPurchase}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({ afterFilter })}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* Purchase breakup details modal       */}
          <Modal
            size="xl"
            isOpen={purchaseDetailsModal}
            toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
          >
            <ModalHeader
              toggle={() => setPurchaseDetailsModal(!purchaseDetailsModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivPurchaseitem");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivPurchaseitem">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("Product Order")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Order Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {Number(filterModalSubTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>       
                         <BootstrapTable
                            keyField="_id"
                            data={purchaseDetails && purchaseDetails}
                            columns={columnPurchasedetails}
                            striped
                            hover
                            bootstrap4
                            filter={filterFactory({afterFilter})}
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Outbound modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundModal}
            toggle={() => setProductOutboundModal(!productOutboundModal)}
          >
            <ModalHeader
              toggle={() => setProductOutboundModal(!productOutboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdOutbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdOutbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductOutBound}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product outbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productOutboundDetailsModal}
            toggle={() =>
              setProductOutboundDetailsModal(!productOutboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductOutboundDetailsModal(!productOutboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdOutbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdOutbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Transfer Outbound")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Outbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {Number(filterModalSubTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                                <BootstrapTable
                            keyField="_id"
                            data={
                              productOutboundDetails && productOutboundDetails
                            }
                            columns={columnsProductOutBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound modal       */}
          <Modal
            size="xl"
            isOpen={productInboundModal}
            toggle={() => setProductInboundModal(!productInboundModal)}
          >
            <ModalHeader
              toggle={() => setProductInboundModal(!productInboundModal)}
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDivProdInbound");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDivProdInbound">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                          <h5>
                            Branch : {selectedBranch.name} | Total :{" "}
                            {Number(filterModalTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
                          </h5>
                          <BootstrapTable
                            keyField="_id"
                            data={selectedRow && selectedRow}
                            columns={columnsProductInBound}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/*Product Inbound breakup details modal       */}
          <Modal
            size="xl"
            isOpen={productInboundDetailsModal}
            toggle={() =>
              setProductInboundDetailsModal(!productInboundDetailsModal)
            }
          >
            <ModalHeader
              toggle={() =>
                setProductInboundDetailsModal(!productInboundDetailsModal)
              }
            >
              {" "}
              <Link
                to="#"
                onClick={() => {
                  printDiv("printDiviProdInbounddetails");
                }}
                className="btn btn-sm btn-success mr-2"
              >
                <i className="fa fa-print"></i> Print
              </Link>
            </ModalHeader>
            <ModalBody>
              <Row id="printDiviProdInbounddetails">
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>
                      {" "}
                      <img
                        src={logo}
                        alt=""
                        height="50"
                        style={{ borderRadius: "5px" }}
                      />{" "}
                    </Col>
                    <Col lg={4}>
                      <CardTitle className="text-center">
                        {props.t("Cost Of Goods Sold Report (Products)")}
                      </CardTitle>{" "}
                    </Col>
                  </Row>{" "}
                  <CardTitle className="text-center">
                    {" "}
                    {props.t("Product Inbound Transfer")}
                  </CardTitle>
                  <CardTitle className="text-center">
                    {props.t("(Product Inbound Transfer Details)")}
                  </CardTitle>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col lg={12}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="mb-0">Branch: {selectedBranch.name}</h5>
        </div>
        <div>
          <h5 className="mb-0">
            Total Qty: {formatUnitsForReport(filterModalTotalQty)}
          </h5>
        </div>
        <div>
          <h5 className="mb-0">Total: {Number(filterModalSubTotal).toLocaleString('en-QA', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}</h5>
        </div>
      </div>                      
                                <BootstrapTable
                            keyField="_id"
                            data={
                              productInboundDetails && productInboundDetails
                            }
                            columns={columnsProductInBoundDetails}
                            striped
                            bootstrap4
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(COGSProductDebug))
);
